import LicenseFormContainer from './LicenseFormContainer';

export default LicenseFormContainer;
